export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20ecommerce%20concept%20with%20curated%20product%20packages%20and%20lifestyle%20accessories%20arranged%20on%20warm%20cream%20textured%20surface%2C%20soft%20golden%20hour%20natural%20light%20streaming%20through%20linen%20curtains%2C%20sophisticated%20neutral%20beige%20amber%20and%20terracotta%20tones%2C%20editorial%20product%20photography%20with%20gentle%20atmospheric%20shadows%2C%20refined%20modern%20aesthetic%2C%20clean%20composition%20with%20depth%20and%20warmth&width=1600&height=900&seq=sugargoo-hero-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet Hub - fashion product discovery platform"
          className="w-full h-full object-cover object-center"
          title="Sugargoo Spreadsheet fashion product discovery"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
          The Ultimate Sugargoo Spreadsheet Hub 2026
        </h2>
        <p className="text-base md:text-lg text-white/90 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Discover thousands of curated Sugargoo finds, product spreadsheets, QC guides, shipping information and expert shopping resources — all in one place.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-200 no-underline cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20"
          >
            Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white text-base font-semibold hover:bg-white/25 transition-all duration-200 no-underline cursor-pointer whitespace-nowrap"
          >
            Buy It Now
            <i className="ri-shopping-cart-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8 md:mt-10">
          {['Updated Daily Resources', 'Beginner Friendly', 'Product Comparison', 'Shopping Safety Guide'].map((item) => (
            <span key={item} className="flex items-center gap-1.5 text-xs md:text-sm text-white/80">
              <i className="ri-checkbox-circle-fill text-primary-400"></i>
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}